import React from "react";

import classNames from "classnames";

import { CheckboxFieldProps } from "@components/inputs/types";
import { useFormContext } from "react-hook-form";

export type SowCustomCheckboxProps = {
	setSelected?: Function;
	setOther?: Function;
} & CheckboxFieldProps;

export const SowCustomCheckboxField = (props: SowCustomCheckboxProps) => {
	const {
		label = "",
		checkboxClassname,
		id,
		required = false,
		labelClassName,
		name,
		value,
		setSelected,
		setOther,
	} = props;

	const { register } = useFormContext();

	const field = register(name, {
		required: {
			value: required,
			message: "COMMON.REQUIRED_FIELD",
		},
		disabled: props.disabled,
	});

	if (setSelected != undefined) {
		return (
			<div className="input--radio u-mar--bottom--tny">
				<input
					id={id}
					className="input--radio__box"
					type="checkbox"
					{...field}
					value={value}
					onChange={() => setSelected(id)}
				/>
				<label htmlFor={id} className="input--radio__label">
					<span>{label}</span>
				</label>
			</div>
		);
	}

	if (setOther != undefined) {
		return (
			<div className="input--check u-mar--bottom--tny">
				<input
					id={id}
					className="input--check__box"
					type="checkbox"
					{...field}
					value={value}
					onChange={(e) => {
						field.onChange(e);
						setOther(e.target.checked);
					}}
				/>
				<label htmlFor={id} className="input--check__label">
					<span>{label}</span>
				</label>
			</div>
		);
	}

	return (
		<div className="input--check u-mar--bottom--tny">
			<input
				id={id}
				className="input--check__box"
				type="checkbox"
				{...field}
				value={value}
			/>
			<label htmlFor={id} className="input--check__label">
				<span>{label}</span>
			</label>
		</div>
	);
};
